module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag_and_match"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 999,
        stickyTop: 0
      }),
      expression: "{ zIndex: 999, stickyTop: 0}"
    }],
    staticClass: "x-column x-sm mtn x-1-3 "
  }, [_c('draggable', {
    staticClass: "dragBox",
    attrs: {
      "id": "questionBox",
      "options": {
        group: {
          name: 'people',
          pull: 'clone',
          put: false
        },
        sort: false
      },
      "move": _vm.checkMove
    },
    on: {
      "end": function($event) {
        _vm._makeChoiceAnswers($event, _vm.question);
      }
    },
    model: {
      value: (_vm.question.possible_draggable_options),
      callback: function($$v) {
        _vm.question.possible_draggable_options = $$v
      },
      expression: "question.possible_draggable_options"
    }
  }, _vm._l((_vm.question.possible_draggable_options), function(choice) {
    return _c('div', {
      staticClass: "dragElement"
    }, [_vm._v(_vm._s(choice))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "choices x-column x-sm mtn x-2-3 "
  }, [_vm._l((_vm.question.drag_and_match), function(choice, choiceIndex) {
    return _c('div', {
      staticClass: "choice"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(choice.option)
      }
    }), _vm._v(" "), (_vm.question.commited && choice.answer.indexOf(choice.correct_match) != 0 && _vm.paid) ? _c('div', {
      staticClass: "sorry"
    }, [_vm._v(_vm._s(choice.correct_match))]) : _vm._e(), _vm._v(" "), (Array.isArray(choice.answer)) ? _c('draggable', {
      key: choice.option,
      staticClass: "matchBox",
      attrs: {
        "options": {
          group: {
            name: 'people'
          }
        },
        "data-index": choiceIndex,
        "move": _vm.checkMoveInner
      },
      on: {
        "end": function($event) {
          _vm._makeChoiceAnswers($event, _vm.question);
        }
      },
      model: {
        value: (_vm.question.drag_and_match[choiceIndex].answer),
        callback: function($$v) {
          _vm.question.drag_and_match[choiceIndex].answer = $$v
        },
        expression: "question.drag_and_match[choiceIndex].answer"
      }
    }, _vm._l((choice.answer), function(choiceEl) {
      return _c('div', {
        staticClass: "dragElement selected",
        class: {
          'correct': _vm.question.commited && choice.answer.indexOf(choice.correct_match) == 0, 'incorrect': _vm.question.commited && choice.answer.indexOf(choice.correct_match) != 0
        },
        on: {
          "click": function($event) {
            _vm.removeChoice(choiceIndex)
          }
        }
      }, [_vm._v(_vm._s(choiceEl))])
    })) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.question.commited && !_vm.paid) ? _c('div', [_vm._v("Answer submitted. Click Continue to proceed.")]) : _vm._e(), _vm._v(" "), (!_vm.question.commited) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.answerDraggable(_vm.question)
      }
    }
  }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), (_vm.question.commited && _vm.question.explanation_input) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.showExplanation = true
      }
    }
  }, [_vm._v("Show Explanation")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-275d0f64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/QuizModels/MultiDragAndMatch.vue
// module id = 44
// module chunks = 0